// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__LOLW8","socials":"Footer_socials__6HtnM","docs":"Footer_docs__L9hbH","icon":"Footer_icon__bAyJA"};